import React, { useContext, useState } from 'react';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Main, Body } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import LoadingAnimation from '../../components/LoadingAnimation';
import TimerFunction from './TimerFunction';

function HandleProceed({
  userId,
  isStudent,
  keyData,
  startDateTimer,
  stateData,
  setStateData,
  onClose,
  refectData,
  whoAdmin,
  parentOnClose,
  toast
}) {
  const { collegeId } = useContext(FirebaseContext);
  const { data: userDetail, isLoading: profileLoading } = useProfileData(userId, !isStudent);
  const [loading, setLoading] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const [values, setValues] = useState({});

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        _id: userId,
        startDate: stateData?.[userDetail?._id + 'timeStamp'],
        endDate: new Date(),
        collegeId,
        customeAdmission: values?.admission,
        customeDate: values?.dateFast,
        whoAdmin,
        key: keyData,
      };

      const instance = await getAxiosTokenInstance();
      const resp = await instance.post('/college/admissionProcess2/verify', payload);

      if (resp?.data?.statusCode !== 200) {
        throw new Error(resp?.data?.message || 'API Error');
      }

      if (refectData) refectData();

    } catch (error) {
      console.log('Handle Proceed Error:', error?.response?.data?.message || error?.message);
    } finally {
      setLoading(false);
      onClose();

      await parentOnClose();
    }
  };

  if (profileLoading) {
    return <div className="text-center p-8">Loading Student Data...</div>;
  }

  if (!userDetail) {
    return <div className="text-center p-8">No student data found.</div>;
  }

  return (
    <Main title="Confirm Verification" width="500px" height="340px" onClick={onClose}>
      <Body>

        <TimerFunction
          start={true}
          date={startDateTimer}
          className="text-base md:text-lg font-mono w-[120px] text-center rounded-md px-2 py-1 
                 bg-slate-800 text-slate-100 
                 dark:bg-slate-100 dark:text-slate-800"
        />

        <div className="flex flex-col items-start justify-center gap-4 p-4">
          {loading && (
            <div className="flex items-center justify-center w-full">
              <LoadingAnimation />
            </div>
          )}

          <p className="text-base text-slate-800 dark:text-slate-100">
            Are you sure you want to verify the details of{' '}
            <span className="font-semibold">{userDetail?.name}</span>?
          </p>


          <label className="flex items-center gap-2 text-sm text-slate-700 dark:text-slate-200">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={acknowledged}
              onChange={() => setAcknowledged(!acknowledged)}
            />
            I acknowledge the data entered is correct
          </label>

          <Button
            width="300px"
            height="45px"
            type="verify"
            onClick={handleSubmit}
            loading={loading}
            disabled={!acknowledged}
          >
            Yes, Verify and Complete
          </Button>

          <Button width="300px" height="45px" type="delete" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Body>
    </Main>
  );
}

export default HandleProceed;